ReceivedGiftCard: 您收到一张礼品卡
HaveGiftCard: 您有一张礼品卡
Sender: '发送者: {0}'
IssuedDate: '赠卡时间: {0}'
Expires: '过期时间: {0}'
Close: 关闭
Refuse: 拒绝
Accept: 接受
